(function () {
  const sections = document.querySelectorAll('[data-barf-supplements]');
  if (!sections.length) return;

  sections.forEach((section) => {
    section.classList.add('fbs-js');

    const revealItems = section.querySelectorAll('.fbs-reveal, .fbs-reveal-card');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('fbs-is-visible');
        observer.unobserve(entry.target);
      });
    }, {
      threshold: 0.14,
      rootMargin: '0px 0px -42px 0px'
    });

    revealItems.forEach((item, index) => {
      if (!item.style.getPropertyValue('--fbs-delay')) {
        item.style.setProperty('--fbs-delay', `${index * 80}ms`);
      }
      observer.observe(item);
    });
  });
})();
